module.exports = __webpack_public_path__ + "static/img/phone-ecode-right.4998e8e1.png";